import Select from 'components/bootstrap/forms/Select';

interface IPCSOSelectLoadingProps {
	ariaLabel: string;
	placeholder?: string;
}
export const PCSOSelectLoading = ({ ariaLabel, placeholder }: IPCSOSelectLoadingProps) => {
	return <Select placeholder={placeholder || 'Loading...'} ariaLabel={ariaLabel} />;
};
